// extracted by mini-css-extract-plugin
export default {"tx":"_6bfc990762","line":"f403ea50ac"};